module.exports = __webpack_public_path__ + "static/img/Leroy.Jetta.a5da2ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Leroy.Jetta.jpg
// module id = /OPd
// module chunks = 0